export const baseStates = {
    items: [],
    selected: {},
    editForm: {},
    indexLoading: false,
    storeLoading: false,
    showLoading: false,
    editLoading: false,
    updateLoading: false,
    deleteLoading: false,

    total: 0,
    to: 1,
    from: 15,
    currentPage: 1,
    nextPage: null,
    lastPage: 1,
    path: null,
    url: null,
};



// WEBPACK FOOTER //
// ./src/stores/base/states.js